<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <b-row>
        <b-col cols="6">
          <div class="d-flex flex-column">
            <b-skeleton class="mt-3 align-self-center" width="180px" height="180px" type="avatar" />
            <b-skeleton class="align-self-center mt-5" width="80%" />
          </div>
        </b-col>
        <b-col cols="6">
          <div class="d-flex flex-column">
            <b-skeleton class="align-self-end" width="100px" />
            <b-skeleton class="align-self-end" width="100px" />
            <b-skeleton-table
              class="mt-2"
              :rows="4"
              :columns="3"
            />
          </div>
        </b-col>
      </b-row>
    </template>
    <b-row>
      <b-col md="6">
        <div class="mc-dashboard__total-expense">
          <div class="expense-chart--pie mt-3">
            <PieChart
              :labels="chartData.labels"
              :datasets="chartData.datasets"
              :options="chartOptions"
            />
          </div>
          <div class="expense-chart--legend gap-3">
            <div v-for="(val, key) in datasets" :key="key" class="d-flex gap-1">
              <div class="__color" :style="{ backgroundColor: val.color }"></div>
              <span class="__label">{{ val.label }}</span>
            </div>
          </div>
        </div>
      </b-col>
      <b-col md="6">
        <div class="mc-dashboard__total-expense-item">
          <div class="d-flex justify-content-end">
            <div class="d-flex flex-column">
              <span class="align-self-end">{{ $t('dashboard.text.totalCost') }}</span>
              <h4 class="align-self-end">Rp. {{ total.toLocaleString() }}</h4>
            </div>
          </div>
          <div class="border border-1">
            <table class="table b-table table-sm">
              <thead>
                <tr>
                  <th class="text-center">{{ $t('dashboard.text.costIndexLabel') }}</th>
                  <th>{{ $t('dashboard.text.costLabel') }}</th>
                  <th>{{ $t('dashboard.text.costAmount') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(val, key) in datasets" :key="key">
                  <td class="text-center">{{ key + 1 }}</td>
                  <td>{{ val.label }}</td>
                  <td class="mc-text-right">{{ val.amount.toLocaleString() }}</td>
                </tr>
                <tr v-if="datasets.length === 0">
                  <td class="text-center" colspan="3">{{ $t('global.text.noData') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-skeleton-wrapper>
</template>
<script>
import PieChart from '@/components/Chart/Pie'
import { expenseByActivity } from '@/services/rest-api/lib/expense/expense'
export default {
  components: {
    PieChart
  },
  props: {
    period: {
      type: Array
    }
  },
  data() {
    return {
      loading: false,
      total: 0,
      datasets: [],
      chartOptions: {
        legend: {
          display: false
        },
        tooltips: {
          bodyFontSize: 18,
          bodySpacing: 9,
          backgroundColor: 'rgb(52 66 100 / 95%)',
          callbacks: {
            label: function(tooltipItem, data) {
              const label = data.labels[tooltipItem.index]
              return `  ${ label }`;
            },
            afterBody: function(tooltipItem, data) {
              const item = tooltipItem[0]
              const amount = data.datasets[item.datasetIndex].data[item.index]
              const alldata = data.datasets[item.datasetIndex].data
              const sum = alldata.reduce((partialSum, current) => partialSum + current, 0)
              const currentValue = Math.round((alldata[item.index] / sum) * 100)

              return `${ currentValue }%\nRp ${ amount.toLocaleString() }`;
            }
          }
        }
      }
    }
  },
  computed: {
    chartData() {
      const labels = [], data = [], color = []
      this.datasets.forEach(val => {
        labels.push(val.label)
        data.push(val.amount)
        color.push(val.color)
      })
      return {
        labels,
        datasets: [
          {
            data,
            label: 'Expense',
            backgroundColor: color
          }
        ]
      }
    }
  },
  watch: {
    period() {
      this.getData()
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const params = {
        reference_type: 'FLEET_TASK',
        start_date: this.period[0],
        end_date: this.period[1]
      }
      const res = await expenseByActivity(params)
      if (res.errors) {
        this.$mcToast.error(res.message)
        return
      }
      this.datasets = res.details_amount
      this.total = res.total_amount
      this.loading = false
    }
  }
}
</script>
<style lang="scss">
.mc-dashboard__total-expense {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  .expense-chart--pie {
    canvas {
      width: 200px !important;
      height: 200px !important;
      margin-left: calc(50% - 100px);
    }
  }
  .expense-chart--legend {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 50px;
    .__color {
      width: 16px;
      height: 16px;
      border-radius: 2px;
    }
    .__label {
      font-size: 10px;
    }
  }
}
.mc-dashboard__total-expense-item {
  .border {
    border-collapse: collapse;
  }
  .mc-text-right {
    text-align: right;
  }
}
</style>
